import React, { useState, useEffect, useContext } from 'react';
import {format, subDays, startOfMonth} from "date-fns";

import * as net from "../../lib/net";
import * as utils from "../../assets/utils";

import Dt_Txt from "../../lib/ui/dt_txt";

//import PdfDlg from "./dlg/pdf_dlg";
//import LoginDlg from "./dlg/login_dlg";
import Dlg_Nota from "./dlg/dlg_nota";

function web01() {

    var html =
    <div className="">
        Test
    </div>
    ;
    return html;
}

class Fkn_Ct extends React.Component {
    //var sdo = useContext(SDOContext); // Functional
    //static contextType = SDOContext; // Class

    constructor(props, context) {
        super(props);

        this.store = props.store;
        this.state = {};
        this.state.gaa = [];
        this.state.loading = 0;
        this.state.sdo = {};
        this.state.nta = [];
        this.state.sortid = "";
        this.state.sortdir = "";
        this.state.wnds = {};
 
        this.state.tot = {};
        this.state.tot.netto = "";
        this.state.tot.brutto = "";
        this.state.tot.resultat = "";

        this.state.today = new Date();
        var dts = format(this.state.today, "yyyy-MM-dd");
        this.state.tdts = dts;
        this.state.dts = dts;
    }
    componentDidMount(){
        this.tbs();
    }

    componentWillUnmount(){
    }

    onScroll(event) {
        var body = document.getElementById("web-body");
        if (body.scrollTop > 150) {
          this.setState({top: 0})
          this.setState({info: 'small'})
        } else {
          this.setState({top: 1})
          this.setState({info: 'big:'+body.scrollTop})
        }

        if (true) {
            var offset = body.scrollTop;
            var start = body.scrollTop;
            var slut = body.scrollTop + window.innerHeight;

            for(var mnuid of this.state.mnus) {
                const element = document.getElementById(mnuid);
                if(!element || (element == null) || (element == undefined)) continue;
                var eltop = element.offsetTop;
                var elbot = element.offsetTop + element.offsetHeight;
                var brc = eltop >= start && eltop <= slut;
                //if(!brc) brc = elbot >= start && elbot <= slut;
                if(brc) {
                    this.setState({mnu_sel: mnuid});
                    return;
                }
            }
        }
    }
    row_css(row) {
        var css = {};
        if(this.state.row) {
            if(this.state.row.ank == row.ank) {
                css.background = "#080";
                css.color = "#fff";
            }
        }
        return css;
    }
    tb_style() {
        var css = {};
        css.height = window.innerHeight - 225;
        return css;
    }
    th_style(id) {
        var css = {};
        css.cursor = "pointer";
        if(id == this.state.sortid) css.color = "#080";
        return css;
    }
    tb_sort(typ) {
        var self = this;

        var nta = self.state.nta;
        var sortid = this.state.sortid;
        var sortdir = this.state.sortdir;

        if(sortid != typ) sortdir = 0;
        else {
            if(sortdir) sortdir = 0;
            else sortdir = 1;
        }
        if(true) {
            if(sortdir) nta.sort((a,b) => (a[typ] < b[typ]) ? 1 : ((b[typ] < a[typ]) ? -1 : 0));
            else nta.sort((a,b) => (a[typ] > b[typ]) ? 1 : ((b[typ] > a[typ]) ? -1 : 0));
        }
        self.setState({ nta: nta, sortid: typ, sortdir: sortdir });
    }

    dt_dts(e) {
        //alert(JSON.stringify(e));
        var dts = format(e, "yyyy-MM-dd");
        this.setState({ dts: dts });
    }
    tbs() {
        var self = this;

        self.setState({ nta: [] });

        if(this.state.dts == this.state.tdts) {
            self.tbs_act();
        }
        else
        {
            self.tbs_hist();
        }
    }
    tbs_act() {
        var self = this;
        var prm = {};
        prm.req = "pos.pos_eko.nota_list";
        //prm.avd = ddo.cache.avd;
        prm.avd = "01";
    
        //gda.wndLoading("Hämtar");
        net.sio_req(prm)
        .then(function(ret){
            //alert(JSON.stringify(ret.rca));
    
            var nta = [];
            for(var nto of ret.rca) {
                if(nto.diff == 0) nta.push( nto );
            }
            self.setState({ nta: nta });
        })
        .catch(function(e){
            var txt = JSON.stringify(e);
            //gda.wndError(txt);
        });
      }
      tbs_hist() {
        var self = this;
        var prm = {};
        prm.req = "pos.pos_eko.invh_list";
        //prm.avd = ddo.cache.avd;
        prm.avd = "01";
        prm.fdat = this.state.dts;
        prm.tdat = this.state.dts;
    
        //gda.wndLoading("Hämtar");
        net.sio_req(prm)
        .then(function(ret){
            //alert(JSON.stringify(ret.rca));
    
            var nta = [];
            for(var nto of ret.rca) {
                if(nto.diff == 0) nta.push( nto );
            }
            self.setState({ nta: nta });
        })
        .catch(function(e){
            var txt = JSON.stringify(e);
            //gda.wndError(txt);
        });
      }
    nota_open(row) {
        var self = this;
    
        var wnds = {};
        wnds.nota = true;
        wnds.dts = this.state.dts;
        wnds.notanr = row.notanr;
        self.setState({wnds: wnds });
      }
    
    render() {
/*
        var stat = [];
        var keys = Object.keys(this.state.stat);
        for (var key of keys) {
            var row = this.state.stat[key];
            stat.push(row);
        }
*/

        return (
            <div className="web-content flex-column">


            <div className="d-flex flex-row justify-content-between">
                <div className="">STÄNGDA BORD</div>
            </div>
                <div className="flex-row justify-content-between">
                    <Dt_Txt dts={this.state.dts} getValue={(e)=> this.dt_dts(e) }/>
                    <div className="cdiblue" onClick={() => this.tbs() }>UPPDATERA</div>
                </div>
                <div className="flex">
                <table className="table table-bordered table-hover tb fixed_header">
                    <thead>
                    <tr>
                        <th style={ this.th_style("bordnr") } onClick={() => this.tb_sort("bordnr") }>Bordsnr</th>
                        <th style={ this.th_style("start") } onClick={() => this.tb_sort("start") }>Start-Slut</th>
                        <th style={ this.th_style("cnr") } onClick={() => this.tb_sort("cnr") }>Kassör</th>
                        <th style={ this.th_style("notanr") } onClick={() => this.tb_sort("notanr") }>Notanr</th>
                        <th style={ this.th_style("fsg") } onClick={() => this.tb_sort("fsg") }>Belopp</th>
                        <th style={ this.th_style("bettyp") } onClick={() => this.tb_sort("bettyp") }>Betaltyp</th>
                    </tr>
                    </thead>
                    <tbody style={ this.tb_style() }>
                    { this.state.nta.map((row, key) =>
                    <tr key={key} onDoubleClick={() => this.nota_open(row) } onClick={() => this.nota_open(row) }>
                        <td className="nof">{ row.bordnr }</td>
                        <td className="nof">{ row.start.cditid() }-{ row.slut.cditid() }</td>
                        <td className="text-left nof">{ utils.toLang(row.ctxt) }</td>
                        <td className="text-center nof">{ row.notanr.ztrim() }</td>
                        <td className="text-right nof">{ row.fsg.cdipris() }</td>
                        <td>{ row.bettyp }</td>
                   </tr>
                    )}
                    </tbody>
                </table>
            </div>
            <div className="">
                <div className="txt_14">STÄNGDA BORD : { this.state.nta.length }</div>
            </div>

            { this.state.wnds.nota ? <Dlg_Nota wnds={this.state.wnds} ctx={this} store={this.props.store} backdrop={true} /> : null}
         </div>
        );
    }

}
//WebPub.contextType = SDOContext; // Function
export default Fkn_Ct;

/*
                    <tr className="">
                        <th>Summa</th>
                        <th className="text-right">{ this.state.tot.netto.cdipris() }</th>
                        <th className="text-right">{ this.state.tot.brutto.cdipris() }</th>
                        <th className="text-right">{ this.state.tot.resultat.cdipris() }</th>
                    </tr>

*/